<template>
  <div>
    <el-dialog v-loading="loading" :close-on-click-modal="false" :close-on-press-escape="false"
               :show-close=false
               :visible="visible"
               center
               title="数据批量编辑"
               width="800px"
    >

      <el-form ref="form" :model="form" :rules="rules" align="center" label-position="right" label-width="100px">
        <el-form-item label="单位名称" prop="school">
          <span slot="label">
            单位学校
            <span style="color: blue;cursor: pointer;margin-left: 5px;" @click="select('1')">全选</span>
            <span style="color: blue;cursor: pointer;margin-left: 10px;" @click="select('2')">反选</span>
          </span>
          <el-select v-model="form.school" filterable multiple style="width: 100%;">
            <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id">{{ item.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" prop="year">
          <el-input-number v-model="form.year" style="width: 100%;"/>
        </el-form-item>
        <el-form-item label="检查项" prop="checkCode">
          <el-select v-model="form.checkCode" filterable style="width: 100%;">
            <el-option v-for="item in checkSchoolItems" :key="item.id" :label="`(${item.code})`+item.name"
                       :value="item.code">
              {{ `(${item.code})` + item.name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item :prop="form.oldValueIsNull?'':'oldValue'" align="left" label="匹配值">
              <el-input v-model="form.oldValue" :disabled="form.oldValueIsNull" style="width:100%;"/>
              <el-switch v-model="form.oldValueIsNull" active-color="red" active-text="匹配值为空"
                         inactive-text="设置匹配值"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="新值" prop="newValue">
              <el-input v-model="form.newValue" style="width: 100%;"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="update">确 认</el-button>
    <el-button @click="close">取 消</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import * as organizationApi from "@/api/gen/organizationApi";
import * as checkItemApi from "@/api/gen/checkItemApi";


export default {
  name: "batchUpdate",
  props: {
    row: {},
    orgList: {}
  },
  data() {
    return {
      schoolList: [],
      checkSchoolItems: [],
      checkNurseryItems: [],
      loading: false,
      form: {
        organizationId: undefined,
        year: undefined,
        school: [],
        checkCode: '',
        oldValue: undefined,
        oldValueIsNull: false,
        newValue: undefined
      },
      visible: false,
      rules: {
        school: [{required: true, message: '请选择学校', trigger: 'blur'}],
        year: [{required: true, message: '请设置年份', trigger: 'blur'}],
        checkCode: [{required: true, message: '请选择检查项', trigger: 'blur'}],
        oldValue: [{required: true, message: '请设置匹配值', trigger: 'blur'}],
        newValue: [{required: true, message: '请设置新值', trigger: 'blur'}],
      },
    }
  },
  watch: {
    'form.oldValueIsNull': {
      deep: true,
      handler() {
        this.rules.oldValue[0].required = !this.form.oldValueIsNull;
        if (this.form.oldValueIsNull) {
          this.form.oldValue = undefined;
        }
        this.$refs.form.validate();
      }
    }
  },
  async mounted() {
  },
  computed: {},
  methods: {
    async open(data) {
      console.log(data)
      this.visible = true;

      this.checkSchoolItems = [];
      this.checkNurseryItems = [];
      this.form.organizationId = data.id;
      this.form.school = [];
      this.form.year = undefined;
      this.form.checkCode = undefined;
      this.form.oldValue = undefined;
      this.form.oldValueIsNull = false;
      this.form.newValue = undefined;
      let res = await organizationApi.list({pageSize: 10000})
      this.schoolList = res.data.filter(item => (item.type === 3 || item.type === 4) && data.schools.includes(item.id))
      const checkRes = (await checkItemApi.list({
        code: '',
        pageNo: 1,
        pageSize: 500
      }));
      let checkItems = checkRes.data;
      this.checkSchoolItems = checkItems.filter(item => item?.types?.includes(1));
      this.checkNurseryItems = checkItems.filter(item => item?.types?.includes(0));
      this.checkSchoolItems.sort((a, b) => {
        return a.sortKey - b.sortKey
      });
      this.checkNurseryItems.sort((a, b) => {
        return a.sortKey - b.sortKey
      });
    },
    /**
     * 选择学校
     * type 1=全选 2=反选
     */
    select(type) {
      if (type == '1') {
        this.form.school = this.schoolList.map(m => m.id);
      } else {
        this.form.school = this.schoolList.filter(f => !this.form.school.includes(f.id)).map(m => m.id);
      }
    },
    close() {
      this.visible = false;
      this.$emit("close")
    },
    async update() {
      try {
        let valid = await this.$refs.form.validate()
        if (valid) {
          this.loading = true;
          await organizationApi.batchUpdate(this.form)
          this.visible = false;
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false;
      }
    },
    async edit() {

    }
  }
}
</script>

<style scoped>


</style>
